import React from 'react';
import ExpressMonitoringPage from '../central/ExpressMonitoringPage';
import NullifyTicketPage from '../central/NullifyTicketPage';
import RevertNullifiedTicketPage from '../central/RevertNullifiedTicketPage';
import PayTicketPage from '../central/PayTicketPage';
import ChangeTerminalPasswordPage from '../central/ChangeTerminalPasswordPage';
import {
  SUPERVISOR_EXPRESS_PORTAL,
  SUPERVISOR_NULLIFY_PORTAL,
  SUPERVISOR_PASSWORD_PORTAL,
  SUPERVISOR_PAY_PORTAL,
  SUPERVISOR_REVERT_PORTAL,
} from './supervisorCentralPortal';

// Le reste du Central company cote superviseur (2026-09-26) — memes pages,
// configurees pour le portail superviseur (cf. supervisorCentralPortal.jsx).
export const SupervisorExpressMonitoringPage = () => <ExpressMonitoringPage portal={SUPERVISOR_EXPRESS_PORTAL} />;
export const SupervisorNullifyTicketPage = () => <NullifyTicketPage portal={SUPERVISOR_NULLIFY_PORTAL} />;
export const SupervisorRevertNullifiedTicketPage = () => <RevertNullifiedTicketPage portal={SUPERVISOR_REVERT_PORTAL} />;
export const SupervisorPayTicketPage = () => <PayTicketPage portal={SUPERVISOR_PAY_PORTAL} />;
export const SupervisorChangeTerminalPasswordPage = () => (
  <ChangeTerminalPasswordPage portal={SUPERVISOR_PASSWORD_PORTAL} />
);
